import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@h2j-data-team/ui";

/**
 * The `back` slot of the library PageHeader: an icon button that is a real link
 * to the parent screen, named by `label`.
 */
export function BackLink({
  to,
  params,
  search,
  label,
}: {
  to: string;
  params?: Record<string, string>;
  search?: Record<string, unknown>;
  label: string;
}) {
  return (
    <Button asChild variant="ghost" size="icon-sm">
      <Link to={to as never} params={params as never} search={search as never} aria-label={label}>
        <ArrowLeft />
      </Link>
    </Button>
  );
}
